var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutstanding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4444 20.4444H2.55556V2.55556H11.5V0H2.55556C1.13722 0 0 1.15 0 2.55556V20.4444C0 21.85 1.13722 23 2.55556 23H20.4444C21.85 23 23 21.85 23 20.4444V11.5H20.4444V20.4444ZM14.0556 0V2.55556H18.6428L6.08222 15.1161L7.88389 16.9178L20.4444 4.35722V8.94444H23V0H14.0556Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutstanding);
export default __webpack_public_path__ + "static/media/Outstanding.43cca97bae5a6582365fe2484041fb5e.svg";
export { ForwardRef as ReactComponent };